import { render, staticRenderFns } from "./NewAccommodation.vue?vue&type=template&id=60535d1d&scoped=true"
import script from "./NewAccommodation.vue?vue&type=script&lang=js"
export * from "./NewAccommodation.vue?vue&type=script&lang=js"
import style0 from "./NewAccommodation.vue?vue&type=style&index=0&id=60535d1d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60535d1d",
  null
  
)

export default component.exports